import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "express_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "特殊区域价格设置", -1);

const _hoisted_7 = {
  class: "base_details_content_second"
};
const _hoisted_8 = {
  class: "table_tag_box"
};
const _hoisted_9 = {
  class: "dialog-footer"
};
import BackTitleView from "@com/BackTitleView.vue";
import DynamicParams from "@com/DynamicParams.vue";
import { ref, reactive } from "vue";
import useRoute from "@util/router";
import $ from "@util/base";
import { $msg } from "@ui/msg";
import api from "@api/express"; // import provinceData from "@/assets/province"

export default {
  __name: 'ExpressDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var title = "邮费模板详情";
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "邮费模板详情";
        getData();
      },
      add: () => {
        title = "新增邮费模板";
      },
      modify: () => {
        title = "修改邮费模板";
        getData();
      }
    });
    const provinceData = ref([]);
    chooseArea();

    function chooseArea() {
      api.chooseArea(val => {
        provinceData.value = val;
      });
    }

    function getData() {
      api.details(route.query().code, val => {
        expressForm.name = val.name;
        expressForm.money = val.money;
        data.value = val.itemList;
      });
    }

    const expressFormRef = ref(null);
    const expressForm = reactive({
      name: '',
      money: ''
    });
    const expressRules = {
      name: [{
        required: true,
        message: '请输入模板名称',
        trigger: 'blur'
      }],
      money: [{
        required: true,
        message: '请输入全国价格',
        trigger: 'blur'
      }]
    };
    const template = {
      areaItemList: [],
      price: null,
      priceNum: 1,
      addPriceNum: 1,
      addPrice: null
    };
    const data = ref([//   {
      //   areaItemList: [
      //     // {
      //     // areaCode: null,
      //     // areaName: null
      //     // }
      //   ],
      //   price: null,
      //   priceNum: 1,
      //   addPriceNum: 1,
      //   addPrice: null
      // }
    ]);
    const dynamicParams = ref(null);
    const dialogVisible = ref(false);
    const areaFormRef = ref('');
    const areaForm = reactive({
      value: ''
    });
    const areaRules = {
      value: [{
        required: true,
        message: '请选择省份',
        trigger: 'change'
      }]
    };

    function addArea(index) {
      areaIndex.value = index;
      dialogVisible.value = true;
    }

    const areaIndex = ref(0);

    function submitAreaForm() {
      areaFormRef.value.validate(valid => {
        if (valid) {
          let areaValue = provinceData.value[areaForm.value];
          let nowValue = dynamicParams.value.getValue()[areaIndex.value];
          nowValue.areaItemList.push(areaValue);
          dynamicParams.value.modifyData(areaIndex.value, nowValue);
          dialogVisible.value = false;
        }
      });
    }

    const delArea = (tag, index) => {
      let nowValue = dynamicParams.value.getValue()[index];
      nowValue.areaItemList.splice(tag, 1);
      dynamicParams.value.modifyData(index, nowValue);
    };

    function save() {
      expressFormRef.value.validate(valid => {
        if (valid) {
          let value = dynamicParams.value.getValue();
          value = value.remove(e => {
            return $.isEmpty(e.areaItemList) && $.isEmpty(e.price) && $.isEmpty(e.addPrice);
          });

          if (checkArea(value)) {
            $.handleCRU(route.query().type, {
              add: () => {
                addData(value);
              },
              modify: () => {
                modifyData(value);
              }
            });
          }
        }
      });
    }

    function addData(value) {
      api.add(expressForm, value, () => {
        $msg.succ("添加成功");
        back();
      });
    }

    function modifyData(value) {
      console.log(value);
      api.update(route.query().code, expressForm, value, () => {
        $msg.succ("修改成功");
        back();
      });
    }

    function checkArea(value) {
      if (value.length <= 0) {
        // $msg.error("请添加区域价格")
        return true;
      }

      let areaCodeList = [];

      for (let i = 0; i < value.length; i++) {
        if ($.isEmpty(value[i].areaItemList)) {
          $msg.error("请添加区域");
          return false;
        } else {
          value[i].areaItemList.map(val => areaCodeList.push(val.areaCode));
        }

        if ($.isEmpty(value[i].priceNum)) {
          $msg.error("请填写首件");
          return false;
        }

        if ($.isEmpty(value[i].price)) {
          $msg.error("请填写首费");
          return false;
        }

        if ($.isEmpty(value[i].addPriceNum)) {
          $msg.error("请填写续件");
          return false;
        }

        if ($.isEmpty(value[i].addPrice)) {
          $msg.error("请填写续费");
          return false;
        }
      }

      let setList = new Set(areaCodeList);

      if (areaCodeList.length != setList.size) {
        $msg.error("区域范围设置重复");
        return false;
      }

      return true;
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
            ref_key: "expressFormRef",
            ref: expressFormRef,
            disabled: _unref(readOnly),
            model: expressForm,
            rules: expressRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "模版名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: expressForm.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => expressForm.name = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "全国价格",
              prop: "money"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: expressForm.money,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => expressForm.money = $event),
                modelModifiers: {
                  number: true
                },
                min: 0,
                precision: 2,
                disabled: _unref(readOnly),
                controls: false,
                "controls-position": "right"
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["disabled", "model"])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(DynamicParams, {
            ref_key: "dynamicParams",
            ref: dynamicParams,
            template: template,
            data: data.value,
            operation: _unref($).DPOperation(_unref(readOnly)),
            showDefault: false,
            addText: "添加"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "区域范围",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.areaItemList, (tag, index) => {
                return _openBlock(), _createBlock(_component_el_tag, {
                  key: index,
                  size: "large",
                  closable: !_unref(readOnly),
                  "disable-transitions": false,
                  onClose: $event => delArea(index, scope.$index)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(tag.areaName), 1)]),
                  _: 2
                }, 1032, ["closable", "onClose"]);
              }), 128)), !_unref(readOnly) ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: $event => addArea(scope.$index),
                size: "default"
              }, {
                default: _withCtx(() => [_createTextVNode("添加区域")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "首件",
              align: "center",
              width: "130"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.priceNum,
                "onUpdate:modelValue": $event => scope.row.priceNum = $event,
                min: 1,
                disabled: _unref(readOnly),
                "controls-position": "right"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "首费(¥)",
              align: "center",
              width: "130"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                modelValue: scope.row.price,
                "onUpdate:modelValue": $event => scope.row.price = $event,
                modelModifiers: {
                  number: true
                },
                placeholder: "请输入",
                disabled: _unref(readOnly)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "续件",
              align: "center",
              width: "130"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.addPriceNum,
                "onUpdate:modelValue": $event => scope.row.addPriceNum = $event,
                min: 1,
                disabled: _unref(readOnly),
                "controls-position": "right"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "续费(¥)",
              align: "center",
              width: "130"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                modelValue: scope.row.addPrice,
                "onUpdate:modelValue": $event => scope.row.addPrice = $event,
                modelModifiers: {
                  number: true
                },
                placeholder: "请输入",
                disabled: _unref(readOnly)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data", "operation"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), !_unref(readOnly) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: save,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogVisible.value = $event),
        title: "添加区域",
        width: "35%",
        top: "35vh",
        class: "base_dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitAreaForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "areaFormRef",
          ref: areaFormRef,
          model: areaForm,
          rules: areaRules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "省份选择",
            prop: "value"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: areaForm.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => areaForm.value = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinceData.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.areaName,
                  value: index
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};